module.exports = __webpack_public_path__ + "static/media/ic-call.561aebaa.svg";